import { Box } from "@mantine/core";

import { colors } from "#app/theme/v2/colors";
import { Loader } from "#components/atoms/Loader/Loader";
import { Text } from "#components/atoms/Typographies/Text";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import {
  QuoteRequestLineAssemblyPrice,
  QuoteRequestLineComputedPrice,
} from "#modules/quoteRequestLinesV2/domain/buildQuoteRequestLineTableRows";
import { NO_PRICE_PLACEHOLDER } from "#modules/quoteRequestLinesV2/domain/getComputedQuoteRequestLinePrice";
import { Flex } from "#shared/view/components/Flex";
import { formatPrice, PartTypeSchema } from "shared";

type Props = {
  line: QuoteRequestLineDto;
  linePrice: QuoteRequestLineComputedPrice | null;
  assemblyPrice: QuoteRequestLineAssemblyPrice | null;
  isAnalyzingOrPredicting: boolean;
};

export const UnitCostCell = ({
  line,
  linePrice,
  assemblyPrice,
  isAnalyzingOrPredicting,
}: Props) => {
  if (line.part.type === PartTypeSchema.enum.CONSUMABLE) {
    return null;
  }

  if (isAnalyzingOrPredicting) {
    return (
      <Flex justify="flex-end">
        <Loader size="small" />
      </Flex>
    );
  }

  return (
    <Box ta="right">
      <Text size="small" color={linePrice ? undefined : colors.text.secondaryDisabled}>
        {linePrice
          ? formatPrice(assemblyPrice ? assemblyPrice.cost : linePrice.partCost)
          : NO_PRICE_PLACEHOLDER}
      </Text>
    </Box>
  );
};
